import { makeStyles } from '@material-ui/core/styles';

export const useCustomAudioFileStyles = makeStyles(theme => ({
  audioFileContainer: {
    flex: 2,
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    display: 'flex',
    borderRadius: 5,
    background: '#D2D2D2',
    backgroundImage: 'radial-gradient(circle,rgba(210, 210, 210, 1) 30%, rgba(173, 131, 43, 1) 160%);',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '50% 70%',
    backdropFilter: 'blur(5px)',
    borderWidth: 3,
    borderCololor: 'red'
  },
  audioFileText: {
    display: 'flex',
    flex: 1,
    padding: theme.spacing(1),
    backgroundColor: `${theme.palette.primary.dark}e6`,
    color: theme.palette.secondary.light,
    top: '50%',
    right: 0,
    position: 'absolute',
    borderRadius: '5px 0px 0px 5px',
    userSelect: 'none',
    gap: theme.spacing(1),
    alignItems: 'center'
  },
  audioFileIcon: {
    flex: 1,
    color: theme.palette.basic.normal,
    fontSize: 90,
    marginTop: 27,
    userSelect: 'none'
  },
  openIcon: {
    color: theme.palette.secondary.light,
    fontSize: 'medium',
    marginBottom: theme.spacing(1)
  }
}));
